/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RecaptchaVersion = "v2" | "v3";
export type ListingCampaignClickoutInput = {|
  listingId: string,
  countryCode?: ?string,
  enquiry: ListingCampaignEnquiryInput,
  recaptchaToken?: ?string,
  recaptchaVersion?: ?RecaptchaVersion,
  signature?: ?string,
  timestamp?: ?number,
  landingPageUrl?: ?string,
  currentUrl?: ?string,
  referrer?: ?string,
  clientMutationId?: ?string,
|};
export type ListingCampaignEnquiryInput = {|
  portal?: ?string,
  client?: ?string,
  originalId?: ?string,
  email: string,
  firstName: string,
  lastName: string,
  fullName: string,
  phone?: ?string,
  message?: ?string,
  postcode?: ?string,
  locality?: ?string,
  route?: ?string,
  streetNumber?: ?string,
|};
export type aggregatesListingCampaignEnquiryFormUpsertMutationVariables = {|
  input: ListingCampaignClickoutInput
|};
export type aggregatesListingCampaignEnquiryFormUpsertMutationResponse = {|
  +listingCampaignClickout: ?{|
    +status: boolean,
    +errors: ?{|
      +captcha: ?string,
      +phone: ?string,
      +offline: ?string,
    |},
  |}
|};
export type aggregatesListingCampaignEnquiryFormUpsertMutation = {|
  variables: aggregatesListingCampaignEnquiryFormUpsertMutationVariables,
  response: aggregatesListingCampaignEnquiryFormUpsertMutationResponse,
|};
*/


/*
mutation aggregatesListingCampaignEnquiryFormUpsertMutation(
  $input: ListingCampaignClickoutInput!
) {
  listingCampaignClickout(input: $input) {
    status
    errors {
      captcha
      phone
      offline
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ListingCampaignClickoutPayload",
    "kind": "LinkedField",
    "name": "listingCampaignClickout",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ListingCampaignClickoutErrors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "captcha",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offline",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aggregatesListingCampaignEnquiryFormUpsertMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "aggregatesListingCampaignEnquiryFormUpsertMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e8831fecb3f19089e768d758390c7e1a",
    "id": null,
    "metadata": {},
    "name": "aggregatesListingCampaignEnquiryFormUpsertMutation",
    "operationKind": "mutation",
    "text": "mutation aggregatesListingCampaignEnquiryFormUpsertMutation(\n  $input: ListingCampaignClickoutInput!\n) {\n  listingCampaignClickout(input: $input) {\n    status\n    errors {\n      captcha\n      phone\n      offline\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '62353c2579f81fa5d0c6905f19791fd5';

export default node;
